import { useLocation } from "@reach/router"
import axios from "axios"
import { navigate } from "gatsby"
import React, { memo, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import {
  parsePhoneNumber
} from "react-phone-number-input"
import "react-phone-number-input/style.css"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import PhoneInputFormItem from "../../../Common/new/input"
import ImageShow from "../../ImageShow/OptimizedImage"
import InputLabel from "../../InputFields"
import FormButtonRed from "../../buttons/formButtonRed/formButtonRed"
import CallIcon from "../../svg/new/CallIcon"
import MessageIcon from "../../svg/new/MessageIcon"
import * as style from "./businessForm.module.css"
import useUserCountry from "../../../hooks/useUserCountry"

const BusinessForm = ({ CustomClass, elementRef }) => {
  const location = useLocation()

  const [loading, setLoading] = useState(false)
  const [className, setClassName] = useState("")

  const defaultCountry = useUserCountry();

  const {
    register,
    handleSubmit,
    reset,
    control,
    setError,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    if (errors.check) {
      setClassName("forces-red")
    }
  }, [errors])

  const onSubmit = value => {
    const parsedPhoneNumber = parsePhoneNumber(value?.phone)
    if (
      parsedPhoneNumber?.country === "IN" &&
      parsedPhoneNumber?.nationalNumber?.length !== 10
    ) {
      setError("phone", {
        type: "manual",
        message: "Enter Valid Number!!",
      })
      return
    }
    let formData = new FormData()
    formData.append("email", value?.email)
    formData.append("full_name", value?.fullname)
    formData.append("phone_number", value?.phone)
    formData.append("budget", value?.budget)
    formData.append("project_details", value?.projectdetail)
    formData.append("source_url", location?.href)
    formData.append("user_approval", value?.userapproval)

    setLoading(true)
    axios({
      method: "post",
      url: `${process.env.GATSBY_API_URL}/wp-json/agile/v1/newinquiry`,
      data: formData,
    })
      .then(function (response) {
        if (response.data?.success) {
          navigate("/thankyou")
          reset({
            email: "",
            phone: "",
            budget: "",
            projectdetail: "",
            fullname: "",
          })
        } else {
          alert("Please try again in sometime \n \nSomething went wrong!")
        }
      })
      .catch(_error => {
        alert("Please try again in sometime \n \nSomething went wrong!")
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const fullnameRequired =
    errors.fullname && errors.fullname.type === "required"
  const fullnamePattern = errors.fullname && errors.fullname.type === "pattern"
  const emailRequired = errors.email && errors.email.type === "required"
  const emailPattern = errors.email && errors.email.type === "pattern"
  const budgetRequired = errors.budget && errors.budget.type === "required"
  const budgetPattern = errors.budget && errors.budget.type === "pattern"

  const list = [
    {
      id: 0,
      icon: <MessageIcon />,
      title: "You can email us here",
      phagraph: "inquiry@agileinfoways.com",
      href: "mailto:inquiry@agileinfoways.com",
    },
    {
      id: 1,
      icon: <CallIcon />,
      title: "You can call us on this",
      phagraph: "+1 470-772-5053",
      href: "tel:+14707725053",
    },
    {
      id: 2,
      icon: <CallIcon />,
      title: "You can call us on this",
      phagraph: "+1 954-361-0686",
      href: "tel:+19543610686",
    },
  ]

  return (
    <section
      className={`dark-bg section_common_padding ${style.business_form} ${CustomClass}`}
      ref={elementRef}
      id="hirescroll"
    >
      <div className="container" data-aos="fade-up" data-aos-delay="50">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={style.business_form_wrap}>
            <div className={style.business_form_right}>
              <SectionsTitle
                title="Contact Us"
                SubTitle="Get in Touch with Us"
                Content="We help your business grow with the all answers you need"
                classnames="bgBlackHeading"
                styleCss={{ display: "none" }}
              />
              <div className={style.pictureDiv}>
                <ImageShow imageData="/images/new/contact_us_image.png" alt="contact-us" />
              </div>
              <div className={style.contact_info_box}>
                <ul className={style.review_list}>
                  {list.map(item => {
                    return (
                      <li key={item?.id}>
                        <div className={style.inner_box}>
                          <i className={style.icon_Box}> {item?.icon} </i>
                          <div>
                            <span className={style.rightLabel}>
                              {item?.title}
                            </span>
                            <a href={item?.href}>{item?.phagraph}</a>
                          </div>
                        </div>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
            <div className={style.business_form_left}>
              <div className={style.business_form_heading}>
                <div className={style.heading_title}>Send Us a Message</div>
                <p>
                  Use our convenient contact form to reach out with questions,
                  feedback, or collaboration inquiries
                </p>
              </div>
              <ul className={style.business_form_listing}>
                <li>
                  <div className={style.two_col}>
                    <div className={style.form_grp}>
                      <InputLabel forTxt="fullname" labelText="Full Name" />
                      <input
                        type="text"
                        className={style.input_grp}
                        placeholder="Full Name"
                        {...register("fullname", {
                          required: true,
                          pattern: /^(?!\s*$)[A-Za-z -]+$/,
                        })}
                      />
                      {fullnameRequired && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Full Name is Required!!{" "}
                        </span>
                      )}
                      {fullnamePattern && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Please Enter Valid Name!!{" "}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className={style.two_col}>
                    <div className={style.form_grp}>
                      <PhoneInputFormItem
                        name="phone"
                        control={control}
                        errors={errors}
                        defaultCountry={defaultCountry}
                        phoneRequired={true}
                        CustomClass={style.input_grp}
                      />
                    </div>
                  </div>
                </li>
                <li>
                  <div className={style.two_col}>
                    <div className={style.form_grp}>
                      <InputLabel forTxt="email" labelText="Email" />
                      <input
                        type="email"
                        className={style.input_grp}
                        placeholder="Email"
                        {...register("email", {
                          required: true,
                          pattern:
                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        })}
                      />
                      {emailRequired && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Email is Required!!{" "}
                        </span>
                      )}
                      {emailPattern && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Please Enter Valid Email!!{" "}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className={style.two_col}>
                    <div className={style.form_grp}>
                      <InputLabel forTxt="budget" labelText="Budget" />
                      <input
                        type="number"
                        className={style.input_grp}
                        placeholder="Budget"
                        {...register("budget", {
                          required: true,
                          pattern: /^\d+(\.\d+)?$/,
                        })}
                      />
                      {budgetRequired && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Budget is Required!!{" "}
                        </span>
                      )}
                      {budgetPattern && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Please Enter Valid Budget!!{" "}
                        </span>
                      )}
                    </div>
                  </div>
                </li>
                <li>
                  <div className={style.full_col}>
                    <div className={style.form_grp}>
                      <InputLabel
                        forTxt="projectdetail"
                        labelText="Project Details"
                      />
                      <textarea
                        type="text"
                        className={style.input_grp}
                        placeholder="Project Details"
                        {...register("projectdetail", {
                          required: true,
                          validate: projectdetail => {
                            if (!projectdetail?.trim()) {
                              return "invalid"
                            }
                          },
                        })}
                      ></textarea>
                      {errors.projectdetail && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Project Details are Required!!{" "}
                        </span>
                      )}
                    </div>
                  </div>
                </li>
                <li>
                  <div className={`${style.submit_area} ${style.check_box_grp}`}>
                    <div className={style.form_grp}>
                      <label className={style.check_Box}>
                        <input
                          type="checkbox"
                          value="true"
                          name="check"
                          {...register("userapproval", {
                            required: false,
                          })}
                        />
                        <p>
                          I agree to receive marketing communication from Agile
                          Infoways LLC.
                        </p>
                      </label>
                      <label className={style.check_Box}>
                        <input
                          type="checkbox"
                          name="check"
                          className={className}
                          {...register("check", {
                            required: true,
                          })}
                        />
                        <p>
                          By sending this form I confirm that I have read and
                          accept the{" "}
                          <a href="/privacy-policy/">
                            Privacy Policy <sup>*</sup>{" "}
                          </a>
                        </p>
                      </label>
                    </div>
                  </div>
                  <div className={style.submit_area}>
                    <div className={style.form_grp}>
                      <FormButtonRed
                        disable={loading}
                        btnText={loading ? "Loading. . ." : "Send Message"}
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </form>
      </div>
    </section>
  )
}

export default memo(BusinessForm)
